<template>
    <div >
        <PrimeExpand />

        <slot />

    </div>
</template>
